module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', [_c('v-ons-toolbar', {
    attrs: {
      "modifier": "transparent"
    }
  }), _vm._v(" "), _c('v-ons-list-title', [_vm._v("Infos")]), _vm._v(" "), _c('v-ons-list', [_c('v-ons-list-item', {
    attrs: {
      "modifier": "chevron",
      "tappable": ""
    },
    on: {
      "click": function($event) {
        return _vm.goTo('home')
      }
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('v-ons-icon', {
    attrs: {
      "fixed-width": "",
      "icon": "fa-home"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("Accueil")])]), _vm._v(" "), _c('v-ons-list-item', {
    attrs: {
      "modifier": "chevron",
      "tappable": ""
    },
    on: {
      "click": function($event) {
        return _vm.signout()
      }
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('v-ons-icon', {
    attrs: {
      "fixed-width": "",
      "icon": "fa-sign-out"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("Déconnexion")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57dbe276","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/side-menu/SideMenu.vue
// module id = 711
// module chunks = 1